import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type PDFOutput } from "shared/api/types/pdf";
import { type SocietyProfileInvoiceParamsInput } from "shared/api/types/society/[societyId]/profiles/[profileId]/accounting/invoice/[invoiceId]";
export const getSocietyProfileAccountingInvoiceGeneratePdfContract: BaseApiContract<
  SocietyProfileInvoiceParamsInput,
  undefined,
  PDFOutput
> = {
  method: HttpMethod.GET,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/accounting/invoice/[invoiceId]/generate-pdf",
  paramsType: {} as SocietyProfileInvoiceParamsInput,
  responseType: {} as PDFOutput,
};
